<template>
  <div class="gaokao-search">
    <div class="module-title">账户信息查询</div>
    <div class="content">
      <h3>您的标日账户信息:</h3>
      <p class="account-info">
        用户名: {{ userInfo.user_name }}
        <br />
        手机号: {{ userInfo.mobile }}
        <br />
        邮<span style="padding-left: 1em">箱</span>: {{ userInfo.user_email }}
      </p>
      <template v-if="userInfo.rx_user_name">
        <p class="bind-title">已绑定的日语训练营账户:</p>
        <p class="bind-info">
          手机号: {{ userInfo.rx_user_name }}
          <span class="cancel-bind" @click="unbind">解除绑定</span>
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import { unbundlingDB } from "@/interface";
const userInfo = JSON.parse(localStorage.getItem("rypc_userInfo")) || {};
export default {
  data() {
    return {
      userInfo,
    };
  },
  methods: {
    unbind() {
      this.$confirm("你确定要解除绑定吗？").then(() => {
        this.unbindDB();
      });
    },
    unbindDB() {
      const userId = this.userInfo.user_id;
      const params = {
        user_id: userId,
      };
      unbundlingDB(params).then((res) => {
        const data = this.$aes128Decrypt(res.data);
        this.userInfo = data;
        localStorage.setItem("rypc_userInfo", JSON.stringify(data));
        this.$message.success("解绑成功");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.gaokao-search {
  border-radius: 2px;
  background: white;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.5);
  height: 100%;
  padding: 12px 15px;
  .content {
    margin: 50px 80px 0;

    h3 {
      font-size: 24px;
      color: #090;
      line-height: 1.6em;
    }
    .account-info {
      font-size: 16px;
      color: #090;
      padding-left: 45px;
      line-height: 2em;
      margin-top: 5px;
    }
    .bind-title,
    .bind-info {
      font-size: 16px;
      color: #666;
      line-height: 2em;
      padding-left: 75px;
      margin-top: 10px;
    }
    .bind-info {
      padding-left: 100px;
      margin-top: 0;
      .cancel-bind {
        color: blue;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
}
</style>
